import React from "react";
import styled from "styled-components";
import { DropdownButton } from "../../../aat/components/UI/Button/Button";
import Dropdown from "../../../aat/components/UI/Dropdown/Dropdown";
import CheckboxField from "../Forms/fields/CheckboxField";

export interface DropDownCheckboxOption
{
    label: string;
    value: string;
    selected: boolean;
}

interface DropDownCheckboxFilterProps
{
    label: string;
    onChange: (options: DropDownCheckboxOption[]) => void;
    options: DropDownCheckboxOption[];
}

const DropDownCheckboxFilterWrap = styled.div`
    position: relative;
    label {
        display: block;
        margin-left: 1rem;
    }
`;

const DropDownCheckboxFilter: React.FC<DropDownCheckboxFilterProps> = (props) =>
{
    //Dropdown state
    const [dropdownVisible, setDropdownVisible] = React.useState(false);

    const getLabel = () =>
    {
        const selectedOptions = props.options.filter(opt => opt.selected);
        if (selectedOptions.length > 0)
        {
            if (selectedOptions.length === 1)
            {
                return selectedOptions[0].label;
            }
        }
        return props.label;
    };

    const setChecked = (optionValue: string) =>
    {
        const updatedOptions = [...props.options];
        const opt = updatedOptions.find(opt => opt.value === optionValue);
        if (opt)
        {
            opt.selected = !opt.selected;
            props.onChange(updatedOptions);
        }
    };

    const handleButtonClick = () =>
    {
        setDropdownVisible(!dropdownVisible);
    };

    return (
        <DropDownCheckboxFilterWrap>
            <DropdownButton onClick={handleButtonClick}>{getLabel()}</DropdownButton>
            <Dropdown
                open={dropdownVisible}
                setOpen={() => setDropdownVisible(!dropdownVisible)}>

                {props.options.map((option, index) => (
                    <div key={index}>
                        <CheckboxField
                            label={option.label}
                            inputProps={{
                                checked: option.selected,
                                type: "checkbox",
                            }}
                            onChange={() => setChecked(option.value)}
                        />
                    </div>
                ))}

            </Dropdown>
        </DropDownCheckboxFilterWrap>
    );
};

export default DropDownCheckboxFilter;